import { findIndex } from 'rxjs/operators';
import { TchekImage } from './../../model/image';
import { ToastService } from './../../service/toast.service';
import { TchekService } from './../../service/tchek.service';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild, OnChanges, DoCheck } from '@angular/core';
import { ModalDismissReasons, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Damage, DamageAnalysis, DamagesGroupedByLocation } from '../../model/damage.model';
import { SeverityVehicleParts, TchekImages } from '../../model/tchekb.model';
import { ClassificationService } from '../../service/classification.service';
import { DamageService } from '../../service/damage.service';
import { ImagesService } from '../../service/images.service';
import { ParametersService } from '../../service/parameters.service';
import { RoiService } from '../../service/roi.service';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { ImageClassification } from '../../model/imageClassification.model';
import { SubscriptionService } from '../../service/subscription.service';
import { ActivatedRoute, Params } from '@angular/router';
import { TchekOldService } from '../../service/tchek-old.service';
const parse: typeof Parse = require('parse');


@Component({
  selector: 'app-annex-picture',
  templateUrl: './annex-picture.component.html',
  styleUrls: ['./annex-picture.component.less']
})
export class AnnexPictureComponent {
  @ViewChild('contentExterior') contentExterior: ElementRef;
  @ViewChild('contentInterior') contentInterior: ElementRef;
  @Input() tchekPtr: string
  @Input() tchekId: string
  
  files: File[] = [];
  saving: boolean = false
  modalRef: NgbModalRef;
  closeResult: string;
  insideClassificationImage = false
  currentMode = 'image'
  tchekExterior: TchekImages;
  tchekInterior: TchekImages;
  currentImage: TchekImage;
  isLoadingPicture: boolean
  tmpImagesExterior: TchekImage[] = [];
  tmpImagesInterior: TchekImage[] = [];
  isInitialised : boolean = false;
  isToReload : boolean = false;


  constructor(
    private readonly _classificationService: ClassificationService,
    readonly _roiService: RoiService,
    private readonly _imageService: ImagesService,
    private modalService: NgbModal,
    private _tchekOldService: TchekOldService,
    private readonly _toastService: ToastService,
    private readonly i18n: I18n,
    public _imagesService: ImagesService,
  ) {}
    
  ngOnChanges(): void {
    if ( this.tchekId && (this.isInitialised === false || this.isToReload === false )) {
      this.isInitialised = true;
      this.isToReload = true;
      this._tchekOldService.getTchek(this.tchekId).then(tchek => {
        this._imagesService.getByTchek(this.tchekId).then(images => {
          images.forEach(image => {
            if(image.images){
              image.images.forEach(image => {
                if (image.isDeleted !== true) 
                {
                  if (image.isInterior === true)
                    this.tmpImagesInterior.push(image)
                  else if (image.isInterior === false)
                    this.tmpImagesExterior.push(image)
                }
              });
              this.tchekExterior = new TchekImages(tchek, this.tmpImagesExterior)
              this.tchekInterior = new TchekImages(tchek, this.tmpImagesInterior)
              this.tmpImagesExterior = []
              this.tmpImagesInterior = []
            }
          });
        })
      })
    }
  }

  onSelect(event) {
    this.files.push(...event.addedFiles);
  }

  onRemove(event) {
    this.files.splice(this.files.indexOf(event), 1);
  }

  openmodalInterior() {
    this.files = []
    this.saving = false
    this.modalRef = this.modalService.open(this.contentInterior, { backdropClass: 'backdropClassModal' });
    this.modalRef.result.then((result) => {
      //console.log('result modal ##################', result);
    }, (reason) => {
      this.files = []
      this._classificationService.active = false
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  openmodalExterior() {
    this.files = []
    this.saving = false
    this.modalRef = this.modalService.open(this.contentExterior, { backdropClass: 'backdropClassModal' });
    this.modalRef.result.then((result) => {
      //console.log('result modal ##################', result);
    }, (reason) => {
      this.files = []
      this._classificationService.active = false
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  async saveTchekExterior() {
      try {
        for await (const file of this.files)
          await this._imageService.saveImages2(file, this.tchekId, false).catch(err => { console.log(err); })
        this.modalRef.close("Saved click")
        this.isToReload = false
      } catch (error) {
        console.log(error);
      }
  }

  async saveTchekInterior() {
      try {
        for await (const file of this.files)
          await this._imageService.saveImages2(file, this.tchekId, true).catch(err => { console.log(err); })
        this.modalRef.close("Saved click")
        this.isToReload = false
      } catch (error) {
        console.log(error);
      }
  }

  switchToImage(image?: TchekImage) {
    this.currentMode = 'image'
    this.currentImage = undefined
    if (image !== undefined)
      this.currentImage = image
    if (this.currentImage === undefined) {
      this._toastService.toastOpen(undefined, this.i18n({
        id: 'noImage',
        value: "Pas d'images sur ce tchek",
        description: 'Pas dimages sur ce tchek',
        meaning: "animation"
      }), 'error')
      this.isLoadingPicture = false;
    } 
    this._imagesService.runReloadImages(this.currentImage)
  }


  deleteImage(image?: TchekImage) {
    this.switchToImage(image)
    if (this.currentImage) 
    {
        this._imagesService.getByTchek(this.tchekId).then(images => {
          images.forEach(image => {
            if(image.images){
              image.images.forEach(image => {
                if (image.id === this.currentImage.id)
                {
                  image.isDeleted = true;
                  image.getParseInstance().save()
                  this.isToReload = false;
                }  
              });
            }
          });
        })
    }
  }

 
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/element/annex-picture/annex-picture.component.ts